module.exports = __webpack_public_path__ + "static/media/image6.9d1a0fd6.png";